module.exports = __webpack_public_path__ + "img/7.3354186c.png";